import { Box } from 'react-scale/components/pages/homepage/build-ai/box';
import { AnnotationTabs, TABS } from 'react-scale/components/pages/homepage/build-ai/tabs';

export const BoxDataLabeling = () => {
  return (
    <Box title="Data Labeling" subtitle="The best quality data to fuel the best performing models.">
      <div className="mt-8 lg:mt-10">
        <AnnotationTabs tabs={TABS} />
      </div>
    </Box>
  );
};
